<template>
  <div
    class="jade-toast"
    role="alert"
  >
    <div class="jade-toast__content">
      <slot name="leading"></slot>
      <jade-text
        variant="text-large"
        weight="regular"
        color="on-color"
        data-testid="main-text"
      >
        {{ text }}
      </jade-text>
    </div>
    <div
      v-if="actionName"
      class="jade-toast__trailing"
      role="button"
    >
      <div
        class="jade-toast__action"
        tabindex="0"
        role="button"
        data-testid="button-action"
        @click="handleClickAction"
        @keyup.enter="handleKeyDown"
        @keyup.space="handleKeyDown"
      >
        <jade-text
          variant="hyperlink-medium"
          color="on-color"
        >
          {{ actionName }}
        </jade-text>
      </div>
    </div>
  </div>
</template>

<script>
import JadeText from '@jade/JadeText/index.vue'

export default {
  name: 'JadeToast',
  components: {
    JadeText
  },
  props: {
    text: String,
    actionName: String,
    onDismiss: Function
  },
  methods: {
    handleClickAction () {
      this.$emit('handleClick')
    },
    handleKeyDown () {
      this.handleClickAction()
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/toast.css';
</style>
